import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import { ILicenceProfile } from "../../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  licence: IFullLicenceDetails;
}

const BreadCrumbs = ({ licenceProfile, licence }: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions`}
        >
          Authorisation Versions
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{licence.regno}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
